export default __webpack_public_path__ + "static/media/3.3210eb09.jpg";